import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { TelegramLogin } from '../components/TelegramLogin';
import { AuthAPI } from '../lib/api';
import { useQueryClient } from '@tanstack/react-query';
import { useToast } from '../components/ui/Toast';

declare global {
  interface Window {
    Telegram?: {
      WebApp?: {
        initData: string;
        ready: () => void;
        expand: () => void;
        colorScheme?: string;
        themeParams?: Record<string, string>;
      };
    };
  }
}

export function LoginPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { toast } = useToast();
  const [autoAuth, setAutoAuth] = useState<'idle' | 'loading' | 'failed'>('idle');

  const handleAuth = useCallback(async (payload: any) => {
    try {
      await AuthAPI.telegramLogin(payload);
      await qc.invalidateQueries({ queryKey: ['me'] });
      navigate({ to: '/' });
    } catch (e: any) {
      toast(e.message ?? 'Помилка авторизації', 'error');
    }
  }, [navigate, qc, toast]);

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (!tg?.initData) return;
    tg.ready();
    tg.expand();
    setAutoAuth('loading');
    AuthAPI.telegramWebApp(tg.initData)
      .then(async () => {
        await qc.invalidateQueries({ queryKey: ['me'] });
        navigate({ to: '/' });
      })
      .catch((e: any) => {
        setAutoAuth('failed');
        toast(e?.message ?? 'Mini App авторизація не вдалась', 'error');
      });
  }, [navigate, qc, toast]);

  const isMiniApp = !!window.Telegram?.WebApp?.initData;

  return (
    <div
      className="flex flex-col items-center justify-center h-screen"
      style={{ background: 'var(--tg-bg)' }}
    >
      <div className="flex flex-col items-center gap-6 w-full max-w-sm px-6">
        <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ background: 'var(--tg-bg-tertiary)' }}>
          <span className="text-3xl">🕐</span>
        </div>
        <div className="text-center">
          <h1 className="text-2xl font-bold text-tg-text">Cron Admin</h1>
          <p className="text-tg-text-secondary mt-1 text-sm">VPS Administration Panel</p>
        </div>
        <div
          className="w-full rounded-xl border border-tg-border p-6 flex flex-col items-center gap-4"
          style={{ background: 'var(--tg-bg-secondary)' }}
        >
          {isMiniApp ? (
            <p className="text-sm text-tg-text-secondary text-center">
              {autoAuth === 'loading' && '⏳ Авторизація через Telegram Mini App…'}
              {autoAuth === 'failed' && '❌ Не вдалось авторизуватись (id не у whitelist?)'}
              {autoAuth === 'idle' && '⏳ Старт…'}
            </p>
          ) : (
            <>
              <p className="text-sm text-tg-text-secondary text-center">
                Відкрий цю сторінку через бота <strong>@vpss_claude_bot</strong> або увійди через Telegram Login:
              </p>
              <TelegramLogin botUsername="vpss_claude_bot" onAuth={handleAuth} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
